module.exports = __webpack_public_path__ + "static/media/IOBE2.6cf18fe3.JPG";